import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { BadgeOption, BadgeType, ButtonSize, ButtonType, ButtonVariant, DropdownOption, DropdownOptionDefault, DropdownOptionGroup, DropdownOptionType, DropdownSelectionType, IconName, PopoverPosition } from '@yupma/ui-kit';
import { EmailLabel, EmailValue } from 'server-model';

@Component({
  selector: 'app-email-input',
  templateUrl: './email-input.component.html',
  styleUrl: './email-input.component.scss',
})

export class EmailInputComponent {
  @Input() name: string = '';
  @Input() label: string = '';
  @Input() value: EmailValue[] = [];
  @Input() required: boolean = false;
  @Input() hideOptional: boolean = false;
  @Input() error: boolean = false;
  @Input() disabled: boolean = false;
  @Input() inlineInfo: string = '';
  @Input() errorText: string = 'This field is required.';
  @Input() showLabel: boolean = true;
  @Output() valueChange = new EventEmitter<EmailValue[]>();


  iconNames = IconName;
  buttonVariants = ButtonVariant;
  popoverPositions = PopoverPosition;
  buttonTypes = ButtonType;
  isEditDropdownOpen: boolean = false;
  isEmailDropdownOpen: boolean = false;
  buttonSizes = ButtonSize;
  dropdownSelectionTypes = DropdownSelectionType;
  emailDropdownOptions: DropdownOptionGroup[] = [];


  // ngOnChanges(changes: SimpleChanges) {
  //   if (!!(changes['value'])) {
  //     this.createEmailDropdown()
  //   }
  // }


  // ngOnInit() {
  //   this.createEmailDropdown()
  // }

  // private createEmailDropdown() {
  //   if (this.value && this.value.length) {
  //     this.emailDropdownOptions = [];
  //     let primaryBadge: BadgeOption = { label: 'Primary', type: BadgeType.TIP };
  //     let emailDropdownGroup = new DropdownOptionGroup('', []);
  //     this.value.forEach((item) => {
  //       let option = new DropdownOptionDefault(DropdownOptionType.DEFAULT, item.label, item.value, false, false, '', '', item.value, '', item.primary ? primaryBadge : undefined);
  //       emailDropdownGroup.options.push(option);
  //     });
  //     this.emailDropdownOptions.push(emailDropdownGroup);
  //   }
  // }

  toggleEditDropdown(state: boolean) {
    this.isEditDropdownOpen = state;
  }

  // toggleEmailDropdown(state: boolean) {
  //   if (this.value && this.value.length) {
  //     this.isEmailDropdownOpen = state;
  //   } else {
  //     this.isEditDropdownOpen = state;
  //   }
  // }

  updateValue(emails: EmailValue[]) {
    this.value = emails;
    this.valueChange.emit(this.value);
    // this.createEmailDropdown()
  }
}
